// MANISH CUSTOM CODE FOR BLOG POSTS - START
// Prev/Next nav buttons that scroll exactly one card at a time, same
// proven pattern as mm-category-cards.js / mm-scented-stories.js.

class MmBlogPostsNav {
  constructor(wrap) {
    this.wrap = wrap;
    this.row = wrap.querySelector('[data-mm-cards-row]');
    this.prevBtn = wrap.querySelector('.mm-blog-posts__nav--prev');
    this.nextBtn = wrap.querySelector('.mm-blog-posts__nav--next');
    if (!this.row || !this.prevBtn || !this.nextBtn) return;

    this.prevBtn.addEventListener('click', () => this.scrollByCard(-1));
    this.nextBtn.addEventListener('click', () => this.scrollByCard(1));
    this.row.addEventListener('scroll', () => this.onScroll(), { passive: true });
    window.addEventListener('resize', () => this.onResize());

    this.updateButtons();
  }

  onScroll() {
    window.clearTimeout(this._scrollTimeout);
    this._scrollTimeout = window.setTimeout(() => this.updateButtons(), 80);
  }

  onResize() {
    window.clearTimeout(this._resizeTimeout);
    this._resizeTimeout = window.setTimeout(() => this.updateButtons(), 120);
  }

  getStep() {
    const firstItem = this.row.querySelector('.mm-blog-posts__item');
    if (!firstItem) return this.row.clientWidth;
    const style = window.getComputedStyle(this.row);
    const gap = parseFloat(style.columnGap || style.gap || '0') || 0;
    return firstItem.getBoundingClientRect().width + gap;
  }

  scrollByCard(direction) {
    this.row.scrollBy({ left: this.getStep() * direction, behavior: 'smooth' });
  }

  updateButtons() {
    const maxScroll = this.row.scrollWidth - this.row.clientWidth;
    const noScrollNeeded = maxScroll <= 2;
    const atStart = this.row.scrollLeft <= 2;
    const atEnd = this.row.scrollLeft >= maxScroll - 2;

    this.prevBtn.disabled = noScrollNeeded || atStart;
    this.nextBtn.disabled = noScrollNeeded || atEnd;
    this.wrap.classList.toggle('mm-blog-posts--no-scroll', noScrollNeeded);
  }
}

function mmInitBlogPostsNav() {
  document.querySelectorAll('.mm-blog-posts__nav-wrap').forEach((wrap) => {
    if (wrap.dataset.mmNavInit) return;
    wrap.dataset.mmNavInit = 'true';
    new MmBlogPostsNav(wrap);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mmInitBlogPostsNav);
} else {
  mmInitBlogPostsNav();
}

document.addEventListener('shopify:section:load', mmInitBlogPostsNav);

// MANISH CUSTOM CODE FOR BLOG POSTS - END
